import { useVuelidate } from '@vuelidate/core'
import { ref, unref, type ComputedRef, watch } from 'vue'
import * as z from 'zod'
import zodToVuelidateTypedSchema from '@/utils/zod/zod-to-vuelidate'
import useLegacyVuelidate from '@/composables/useLegacyVuelidate'

export default function useSwordForm(
  { validationSchema, formState }: { validationSchema: z.ZodSchema | ComputedRef<z.ZodSchema>, formState: object | ComputedRef },
) {

  const $v = ref()
  const vuelidateRules = ref(zodToVuelidateTypedSchema(unref(validationSchema)))
  const vm$V = useLegacyVuelidate(vuelidateRules, formState)
  const v$ = useVuelidate(vuelidateRules, formState)

  watch(
    [() => formState, () => validationSchema],
    () => {
      vuelidateRules.value = zodToVuelidateTypedSchema(unref(validationSchema))
    },
    { deep: true },
  )

  watch(() => vm$V, () => {
    $v.value = vm$V.value
  }, { deep: true, immediate: true })

  return { vuelidateRules, v$, $v }
}
